const FETCH_PREFERENCES_SUCCESS = 'FETCH_PREFERENCES_SUCCESS';

export { FETCH_PREFERENCES_SUCCESS };
